import Jockeys from './index'
export default function(globalConfig) {
  if (typeof window === 'undefined') {
    return
  }
  if (globalConfig.nativeSearchSpu) {
    Jockeys.registerBarAction({
      iconUrl: 'https://cdn.poizon.com/node-common/8f9a58b91ecd25221d283e893b014b45.png',
      nativeUrl: '/mySell/SearchHome?fromTag=H5MainMarketPlace&where=seller'
    })
  }
}
